import React from "react";
import MightyInput from "mighty-input";

import "./style.css";

export function NumberGroups({ value = "", ...props }) {
  // Fix value
  const filter = (next, prev) => (/^\d*$/.test(next) ? next : prev);

  // Render unprinted part of value in other colour
  const render = next => {
    const l = next.length;
    const remain = l % 3;
    const n = (l - remain) / 3;
    const out = [];

    if (remain) {
      out.push(<span key={0}>{next.slice(0, l - n * 3)}</span>);
    } else {
      out.push(<span key={0}>{next.slice(0, 3)}</span>);
    }

    for (let i = remain ? 0 : 1; i < n; i++) {
      const start = Math.max(remain - 1, remain) + i * 3;
      out.push(
        <span key={i + 1} className={"numberGroups-group"}>
          {next.slice(start, start + 3)}
        </span>,
      );
    }

    return out;
  };

  return (
    <MightyInput
      value={value}
      className="myInput"
      filter={filter}
      render={render}
      {...props}
    />
  );
}
